import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  FormHelperText,
  Input,
  Image,
  Select,
  Box,
  Flex,
  Text,
  Button,
  SimpleGrid,
  Textarea,
  TableContainer,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Checkbox,
  Td,
  TableCaption,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useToast,
} from "@chakra-ui/react";
import { useSelector } from "react-redux";

import { Card, CardHeader, CardBody, CardFooter } from "@chakra-ui/react";
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";

import axios from "axios";

import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";

import { useLocation } from "react-router-dom";
const array = [
  "Malda",
  "Uttar Dinajpur",
  "Dakshin Dinajpur",
  "Murshidabad",
  "Birbhum",
  "Hoogly",
  "Paschim Bardhaman",
  "Purba Bardhaman",
  "Alipurduar",
  "Cooch Behar",
  "Darjeeling",
  "Jalipaiguri",
  "Kalingpong",
  "Howrah",
  "Kolkata",
  "Nadia",
  "North 24 Pargana",
  "South 24 Pargana",
  "Bankura",
  "Jhargram",
  "Purulia",
  "Purba Medinipur",
  "Paschim Medinipur",
];

let fiterArray = array.sort((a, b) => {
  return a.localeCompare(b);
});

//console.log(fiterArray);
const NcRegister = () => {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const customerId = localStorage.getItem("customerId");

  const token = localStorage.getItem("token");
  const [data, setData] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editItemId, setEditItemId] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const cancelRef = useRef();
  const [formData, setFormData] = useState({
    name: "",
    phoneNo: "",
    address: "",
    gstNo: "",
  });

  //const customerId=localStorage.getItem('customerId');

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `https://api.rasoi.launchlysoftware.in/api/getNc/${customerId}`,
      );
      setData(response.data.nc);
      //console.log(response.data.user)
    } catch (error) {
      toast.error(error.message);
    }
  };
  const edit = (item) => {
    setIsEditing(true);
    setEditItemId(item._id);
    setFormData({
      name: item.name,
      phoneNo: item.phoneNo,
      address: item.address,
      gstNo: item.gstNo,
    });
  };
  console.log(formData, "formData");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: checked, // Set formData.halfPlate to true/false based on checkbox state
    }));
  };

  useEffect(() => {
    fetchData();
  }, [customerId]);

  const validateForm = () => {
    const requiredFields = ["name", "phoneNo"];

    for (const field of requiredFields) {
      if (!formData[field]) {
        return false;
      }
    }
    return true;
  };
  //  const handleSubmit=async(e)=>{
  //     e.preventDefault();
  //     if(!validateForm()) {
  //       toast.error("Please fill in all required fields.");
  //       return;
  //     }
  //     setFormData({
  //         name:formData.name,
  //         address:formData.address,
  //         phoneNo:formData.phoneNo,
  //         gstIn:formData.gstIn,
  //         openingBalance:formData.openingBalance,
  //     })

  //  }

  const save = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      toast.error("Please fill in all required fields.");
      return;
    }
    try {
      if (isEditing) {
        const response = await axios.put(
          `https://api.rasoi.launchlysoftware.in/api/ncUpdate/${customerId}/${editItemId}`,
          { data: formData },
        );
        toast.success(response.data.message);
        setIsEditing(false);
        setEditItemId(null);
      } else {
        const response = await axios.post(
          "https://api.rasoi.launchlysoftware.in/api/ncRegister",
          {
            customerId: customerId,
            data: formData,
          },
        );
        // console.log('Data Submitted: ',response.data);

        toast.success(response.data.message);
      }
      setFormData({
        name: "",
        phoneNo: "",
        address: "",
        gstNo: "",
      });
      fetchData();
    } catch (error) {
      toast.error(error.meesage);
    }
  };
  //  console.log(formData,'formdata');

  // console.log(arr)

  //console.log(newObj);

  const openModal = (id) => {
    setDeleteItemId(id);
    setIsOpen(true);
  };

  const onClose = () => {
    setIsOpen(false);
    setDeleteItemId(null);
  };
  const handleDelete = async () => {
    try {
      const response = await axios.delete(
        `https://api.rasoi.launchlysoftware.in/api/ncDelete/${customerId}/${deleteItemId}`,
      );
      toast.success(response.data.message);
      setIsOpen(false);
      setDeleteItemId(null);
      fetchData();
    } catch (error) {
      toast.error(error.message);
    }
  };

  // due=total-advance
  return (
    <Box
      bg="#f7f7f7"
      p="4"
      color="black"
      width="100%"
      height="100vh"
      overflow="hidden"
      display="flex"
      flexDirection="column"
    >
      <Text
        fontSize="2xl"
        fontWeight="bold"
        textAlign="center"
        color="black"
        mb={4}
      >
        NC Register
      </Text>

      <FormControl isRequired onSubmit={save}>
        <SimpleGrid columns={3} spacing={4}>
          <Box
            display="flex"
            alignItems="center"
            boxShadow="md"
            borderRadius="8px"
            bg="white"
            p={3}
          >
            <FormLabel mb="0" minW="80px">
              Name
            </FormLabel>
            <Input
              bg="#FAFAFA"
              placeholder="Name"
              border="1px solid #ffe4d9"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              size="sm"
            />
          </Box>

          <Box
            display="flex"
            alignItems="center"
            boxShadow="md"
            borderRadius="8px"
            bg="white"
            p={3}
          >
            <FormLabel mb="0" minW="80px">
              Phone No
            </FormLabel>
            <Input
              bg="#FAFAFA"
              placeholder="Phone Number"
              border="1px solid #ffe4d9"
              name="phoneNo"
              value={formData.phoneNo}
              onChange={handleInputChange}
              size="sm"
            />
          </Box>

          <Box
            display="flex"
            alignItems="center"
            boxShadow="md"
            borderRadius="8px"
            bg="white"
            p={3}
          >
            <FormLabel mb="0" minW="80px">
              Address
            </FormLabel>
            <Textarea
              bg="#FAFAFA"
              placeholder="Address"
              border="1px solid #ffe4d9"
              name="address"
              value={formData.address}
              onChange={handleInputChange}
              size="sm"
              rows={1}
            />
          </Box>
        </SimpleGrid>

        <Box mt={4} display="flex" justifyContent="flex-end">
          <Button
            variant="solid"
            color="white"
            bg="#0F3D2E"
            _hover={{ color: "#0F3D2E", bg: "white" }}
            onClick={save}
          >
            {isEditing ? "Update" : "Save"}
          </Button>
        </Box>
      </FormControl>
      <TableContainer
        width="full"
        overflowY="auto"
        maxH="calc(50vh - 100px)"
        mt={4}
        border="1px solid black"
        p={4}
        bg="white"
        borderRadius="10px"
        fontSize="sm"
      >
        <Table size="sm" variant="striped" colorScheme="teal">
          <TableCaption>Nc Data</TableCaption>
          <Thead>
            <Tr>
              <Th>Name</Th>
              <Th>PhoneNo</Th>
              <Th>Address</Th>

              <Th>Edit</Th>
              <Th>Delete</Th>
            </Tr>
          </Thead>
          <Tbody>
            {data?.map((item, index) => (
              <Tr key={index}>
                <Td>{item.name}</Td>
                <Td>{item.phoneNo}</Td>
                <Td>{item.address}</Td>

                <Td>
                  <Button
                    colorScheme="green"
                    size="sm"
                    onClick={() => edit(item)}
                  >
                    Edit
                  </Button>
                </Td>
                <Td>
                  <Button
                    colorScheme="red"
                    size="sm"
                    onClick={() => openModal(item._id)}
                  >
                    Delete
                  </Button>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Confirm Deletion
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure you want to delete this item?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={handleDelete} ml={3}>
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
};

export default NcRegister;
